<template>
  <div class="flex flex-col gap-4">
    <p class="text-sm font-medium leading-normal text-muted-foreground">
      Tags are how this asset is grouped in analytics — asset class, strategy,
      liquidity, access. Every dimension in the repository is available, and
      nothing here is required.
    </p>

    <div class="p-5 bg-card border border-border rounded-ds-lg shadow-ds-sm">
      <TagChips
        :selected
        :suggestions
        :note
        :loading
        :askable
        removable
        @accept="emit('accept', $event)"
        @remove="emit('remove', $event)"
        @add="emit('add')"
        @ask="emit('ask')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { TagRef } from '@/entities/tags/utils/types'

import TagChips from '@/entities/tags/components/TagChips.vue'

/*
 * The tags step. The same chips the summary shows, with room for the
 * explanation the summary has no space for — one list, two places to reach it.
 */
defineProps<{
  selected: TagRef[]
  suggestions: TagRef[]
  note?: string
  /** The tag assistant has not answered yet. */
  loading?: boolean
  /** Offers the "Ask AI" chip — see TagChips. */
  askable?: boolean
}>()

const emit = defineEmits<{
  (e: 'accept', tag: TagRef): void
  (e: 'remove', tag: TagRef): void
  (e: 'add'): void
  /** The "Ask AI" chip was tapped — see TagChips. */
  (e: 'ask'): void
}>()
</script>
